import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./errors.scss";

// ─── Iconos SVG inline para cada tipo de notificación ───

const ToastIcon = ({ type }) => {
  const icons = {
    error: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
        <path d="M15 9L9 15M9 9l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
    success: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
        <path d="M8 12.5l2.5 2.5L16 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    warning: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M12 3L2 21h20L12 3z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        <path d="M12 10v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="17.5" r="1" fill="currentColor" />
      </svg>
    ),
    info: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
        <path d="M12 11v5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="8" r="1" fill="currentColor" />
      </svg>
    ),
  };
  return <span className={`toast-icon toast-icon--${type}`}>{icons[type]}</span>;
};

const ToastBody = ({ type, title, message }) => (
  <div className="toast-body-custom">
    <ToastIcon type={type} />
    <div className="toast-text">
      <strong className="toast-title">{title}</strong>
      {message && <p className="toast-message">{message}</p>}
    </div>
  </div>
);

const baseConfig = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
};

// ─── Notificaciones públicas ───

export const notifyError = (title = "Error", message = "Ocurrió un error, intenta de nuevo.") => {
  toast.error(<ToastBody type="error" title={title} message={message} />, {
    ...baseConfig,
    className: "toast-custom toast-custom--error",
    icon: false,
  });
};

export const notifySuccess = (title = "Listo", message = "Acción realizada correctamente.") => {
  toast.success(<ToastBody type="success" title={title} message={message} />, {
    ...baseConfig,
    className: "toast-custom toast-custom--success",
    icon: false,
  });
};

export const notifyWarning = (title = "Atención", message = "Algo necesita tu atención.") => {
  toast.warn(<ToastBody type="warning" title={title} message={message} />, {
    ...baseConfig,
    className: "toast-custom toast-custom--warning",
    icon: false,
  });
};

export const notifyInfo = (title = "Información", message = "") => {
  toast.info(<ToastBody type="info" title={title} message={message} />, {
    ...baseConfig,
    className: "toast-custom toast-custom--info",
    icon: false,
  });
};
